import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Instagram from '../../homepage/components/instagram/Instagram';
import Products from './components/products/Products';

document.addEventListener('DOMContentLoaded', () => {
  const productsElement = document.getElementById('products');
  let { productIds } = productsElement.dataset;
  productIds = JSON.parse(productIds);

  createRoot(
    productsElement,
  ).render(
    <Provider store={window.store}>
      <Products productIds={productIds} />
    </Provider>,
  );

  const instagramElement = document.getElementById('instagram');
  const { token } = instagramElement.dataset;

  createRoot(
    instagramElement,
  ).render(
    <Instagram token={token} />,
  );

  const StickyCategories = React.lazy(() => import('../../homepage/components/sticky_categories/StickyCategories'));
  createRoot(
    document.getElementById('react-sticky-categories'),
  ).render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
  );
});
